import { render, staticRenderFns } from "./productOrderCompany.vue?vue&type=template&id=5f8e8ecd&"
import script from "./productOrderCompany.vue?vue&type=script&lang=js&"
export * from "./productOrderCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports